import { Typography, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';

export const NumericBulletSection = ({
  bulletNumber,
  title,
  children,
}: PropsWithChildren<{
  bulletNumber: number;
  title: string;
}>) => {
  return (
    <Stack direction='row' gap='24px' alignItems='start'>
      <Typography variant='h4'>{`${bulletNumber}.`}</Typography>
      <Stack width='100%' gap='40px'>
        <Typography variant='h4'>{title}</Typography>
        {children}
      </Stack>
    </Stack>
  );
};
